// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__3FXn4","shimmer":"Placeholder_shimmer__28TxP"};